<template>
  <main>
    <b-row>
      <b-col cols="6" offset="3" class="pt-4 mt-4"> 
        <div class="login-box">
          <a :to="{ name: home }" class="logo"><img src="/images/logo-mynd.svg" alt="Mynd - Context Mining" /></a>
          <h2 class="tagline">Confirm Reset Password</h2>
          <b-overlay :show="show" rounded="sm">
            <p>{{ message }}</p>
          </b-overlay>
          <div class="d-flex justify-content-between mt-4">
            <router-link :to="{ name: 'Login' }" class="sidelink">Back to Login</router-link>
          </div>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
import axios from "axios";
export default {
  name: 'ResetConfirm',
  data() {
    return {
        message: 'Processing your request...',
        show: true,
        token: null,
    };
  },
  mounted() {
    // Try to read token from several places and then send the request
    const qsToken = this.$route && this.$route.query && this.$route.query.token;
    const paramsToken = this.$route && this.$route.params && this.$route.params.token;
    // fallback to raw search in case router didn't parse it for some reason
    const searchToken = (typeof window !== 'undefined' && window.location && window.location.search)
      ? new URLSearchParams(window.location.search).get('token')
      : null;
    // also check hash fragment like #token=... (rare)
    const hashToken = (typeof window !== 'undefined' && window.location && window.location.hash)
      ? (new URLSearchParams(window.location.hash.replace(/^#/, '?')).get('token'))
      : null;

    const token = qsToken || paramsToken || searchToken || hashToken || null;
    this.token = token;

    if (!token) {
      this.message = 'No reset token found in the URL.';
      this.show = false;
      return;
    }

    this.sendUpdatePassEmail(token);
  },
  methods: {
    async sendUpdatePassEmail(token) {
      // Ensure token is a string and decode in case it's URL-encoded
      const safeToken = token ? decodeURIComponent(String(token)) : '';
      if (!safeToken) {
        this.message = 'Invalid reset token.';
        this.show = false;
        return;
      }

      const User = new FormData();
      User.append('token', safeToken);
      try {
        const headers = {};
        console.log("Sending reset password confirmation for token:", safeToken);
        await axios.post(`/forget_password`, User, { headers });
        this.message = 'The instructions to reset your password have been sent to your email.';
      } catch (error) {
        let msg = 'An error occurred.';
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.$toasted.show(msg, { type: 'error' });
        this.message = msg;
      } finally {
        this.show = false;
      }
    }
  }
}
</script>